var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-snackbar md-theme-default md-active md-position-bottom-right"},[_c('transition-group',{class:_vm.classesOfPosition,attrs:{"tag":"div","name":"vue-toast"}},_vm._l((_vm.toasts),function(toast,index){return _c('vue-toast',{key:toast.uid,attrs:{"config":toast,"position":index}})}),1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }